import { createPortal } from 'react-dom';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import BillPaperToPrint from '../../../pages/BillPaperToPrint';
import { getAutoPrint } from '../../../utils/printerSettings';
import { electronPrint, isElectron } from '../../../services/electronPrint.service';

export default function BillPaperToPrintPopup({ isOpen, isCopy = false, onPrintComplete, paymentResponse }) {
  const componentRef = useRef();
  const billData = useSelector(state => state.bill.data);
  const pos = useSelector(state => state.pos);

  useEffect(() => {
    if (!isOpen) return;

    const style = document.createElement('style');
    style.id = 'print-style-popup';
    document.head.appendChild(style);

    const printTimer = setTimeout(async () => {
      if (isElectron()) {
        await electronPrint('bill', { billData, pos, paymentResponse, isCopy });
        if (onPrintComplete) setTimeout(() => onPrintComplete(), 200);
        return;
      }
      if (getAutoPrint()) {
        window.print();
        if (onPrintComplete) setTimeout(() => onPrintComplete(), 500);
      }
    }, 800);

    return () => {
      clearTimeout(printTimer);
      const styleElement = document.getElementById('print-style-popup');
      if (styleElement) styleElement.remove();
    };
  }, [isOpen, onPrintComplete, billData, pos, paymentResponse, isCopy]);

  if (!isOpen || !billData) return null;

  return (
    <>
      {createPortal(
        <div className="section-to-print-receipt-page pb-10">
          <BillPaperToPrint
            ref={componentRef}
            type="invoice"
            copy={isCopy}
            bill={billData}
            order={{
              id: billData.order?.id,
              orderID: billData.order?.id,
              billStatus: billData.status === 'COMPLETED' ? 2 : 1,
              receiptNo: billData.receipt_no,
              receipt_no: billData.receipt_no,
              employee: billData.userBusinessGroup,
              employee_id: billData.userBusinessGroup?.id,
              order_type: billData.order?.order_type,
              start_time: billData.created_at,
              operation_date: billData.created_at,
              branchTable: billData.order?.branchTable,
              member: billData.member,
              remark: billData.order.remark,
              product: mapOrderItemsToProducts(billData.billItems, billData.order?.order_type)
            }}
            branch={{
              id: billData.order?.branchPosSelling?.branchPos?.branch?.id,
              code: billData.order?.branchPosSelling?.branchPos?.branch?.code,
              name: billData.order?.branchPosSelling?.branchPos?.branch?.branch_name,
              business: {
                businessdetail: {
                  img_url: billData.order?.branchPosSelling?.branchPos?.branch?.image_path,
                  prefix: '',
                  name: billData.order?.branchPosSelling?.branchPos?.branch?.business?.company_name,
                  suffix: '',
                  taxpaper_id_number: billData.order?.branchPosSelling?.branchPos?.branch?.business?.tax_number
                }
              },
              financial: {
                is_include_service_charge: false,
                service_charge: billData.service_charge_percent || ''
              }
            }}
            pos={{
              code: billData.order?.branchPosSelling?.branchPos?.pos_id
            }}
            user={{
              firstNameTH: billData.userBusinessGroup?.first_name,
              lastNameTH: billData.userBusinessGroup?.last_name
            }}
            paymentResponse={paymentResponse}
          />
        </div>,
        document.body
      )}
    </>
  );
}

function mapOrderItemsToProducts(billItems, orderStatus) {
  if (!billItems || !Array.isArray(billItems)) return [];

  return billItems
    .map(item => {
      const orderItem = item.orderItem;
      if (!orderItem) return null;
      console.log('item : ', item);

      return {
        id: item.id,
        orderID: orderItem.order_id,
        productName: orderItem.product?.name || orderItem.item_name,
        productQty: item.quantity,
        productPrice: item.price,
        productPricePerPiece:
          orderStatus === 'DELIVERY'
            ? (item.orderItem.product?.branchProduct &&
              item.orderItem.product?.branchProduct.length > 0 &&
              item.orderItem.product?.branchProduct[0].data?.price_delivery
                ? item.orderItem.product?.branchProduct[0].data?.price_delivery
                : item.orderItem.product?.branchProduct[0].data?.price || item.orderItem.product?.price_delivery) || 0
            : (item.orderItem.product?.branchProduct &&
              item.orderItem.product?.branchProduct.length > 0 &&
              item.orderItem.product?.branchProduct[0].data?.price
                ? item.orderItem.product?.branchProduct[0].data?.price
                : item.orderItem.product?.branchProduct[0].data?.price || item.orderItem.product?.price) || 0,
        productStatus: orderItem.is_active ? 1 : 3,
        optionstandard: mapOptions(orderItem.orderProductOption),
        optionproduct: mapSpecificOptions(orderItem.orderProductSpecificOption),
        optionnote: mapAnnotations(orderItem.orderProductAnnotation)
      };
    })
    .filter(Boolean);
}

function mapOptions(options) {
  if (!options || !Array.isArray(options)) return [];

  return options.map(option => ({
    listName: option.productOptionItem?.name || '',
    listPrice: parseFloat(option.qty || 0) * parseFloat(option.productOptionItem?.price || 0),
    optionQty: option.qty || 1
  }));
}

function mapSpecificOptions(options) {
  if (!options || !Array.isArray(options)) return [];

  return options.map(option => ({
    listName: option.productSpecificOptionItem?.name || '',
    listPrice: parseFloat(option.qty || 0) * parseFloat(option.productSpecificOptionItem?.price || 0),
    optionQty: option.qty || 1
  }));
}

function mapAnnotations(annotations) {
  if (!annotations || !Array.isArray(annotations)) return [];

  return annotations.map(annotation => ({
    listName: annotation.productAnnotationItem?.name || ''
  }));
}
